import { createContext, useContext, useState } from "react";

const ShopFilterContext = createContext();

export const useShopFilter = () => {
  const context = useContext(ShopFilterContext);
  if (!context) {
    throw new Error('useShopFilter must be used within a CategoryTreeProvider');
  }
  return context;
};

export function ShopFilterProvider({ children }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [ordering, setOrdering] = useState("-created_at");


  const resetFilters = () => {
    setAppliedFilters({});
    setOrdering("-created_at");
    setSearchTerm("");
  };

  return (
    <ShopFilterContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        appliedFilters,
        setAppliedFilters,
        ordering,
        setOrdering,
        resetFilters
      }}
    >
      {children}
    </ShopFilterContext.Provider>
  );
}